import React from 'react';

interface QuizControlsProps {
    onPrev: () => void;
    onNext: () => void;
    isFirst: boolean;
    isLast: boolean;
    isReviewing: boolean;
    isLastInRegular: boolean;
    hasReviewItems: boolean;
    displayLanguage: 'pt' | 'en' | 'es';
}

const QuizControls: React.FC<QuizControlsProps> = ({ onPrev, onNext, isFirst, isLast, isReviewing, isLastInRegular, hasReviewItems, displayLanguage }) => {
    
    const isFinishing = (isReviewing && isLast) || (isLastInRegular && !hasReviewItems);
    const isGoingToReview = isLastInRegular && hasReviewItems;

    let nextButtonText = displayLanguage === 'en' ? 'Next Question' : displayLanguage === 'es' ? 'Siguiente pregunta' : 'Próxima Questão';
    if (isFinishing) {
        nextButtonText = displayLanguage === 'en' ? 'Finish Exam' : displayLanguage === 'es' ? 'Finalizar examen' : 'Finalizar Exame';
    } else if (isGoingToReview) {
        nextButtonText = displayLanguage === 'en' ? 'Go to Review' : displayLanguage === 'es' ? 'Ir a revisión' : 'Ir para Revisão';
    }

    const getNextButtonColorClass = () => {
        if (isFinishing) {
            return "bg-red-600 hover:bg-red-700 text-white"; // Vermelho para finalizar
        }
        if (isReviewing || isGoingToReview) {
            return "bg-yellow-500 hover:bg-yellow-600 text-black"; // Amarelo para revisão
        }
        return "bg-orange-500 hover:bg-orange-600 text-white"; // Laranja padrão
    };
    
    const commonButtonClasses = "font-bold py-2 px-6 rounded-lg transition-colors";

    return (
        <div className="flex justify-between items-center mt-auto p-4 bg-white dark:bg-slate-800 rounded-lg shadow-lg sticky bottom-4 z-10">
            <button
                onClick={onPrev}
                disabled={isFirst}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 dark:bg-slate-600 dark:hover:bg-slate-500 dark:text-white font-bold py-2 px-6 rounded-lg transition-colors disabled:bg-gray-100 disabled:text-gray-400 dark:disabled:bg-slate-700 dark:disabled:text-slate-500 disabled:cursor-not-allowed"
            >
                <i className="fas fa-arrow-left mr-2"></i>
                {displayLanguage === 'en' ? 'Previous' : displayLanguage === 'es' ? 'Anterior' : 'Anterior'}
            </button>
            <button
                onClick={onNext}
                className={`${commonButtonClasses} ${getNextButtonColorClass()}`}
            >
                {nextButtonText}
                 <i className="fas fa-arrow-right ml-2"></i>
            </button>
        </div>
    );
};

export default QuizControls;
